const routes = {
  path: 'naturezas',
  name: 'Naturezas',
  component: () => import('./Naturezas.vue'),
  children: [
    {
      path: 'inserir',
      name: 'Naturezas_Inserir',
      component: () => import('./NaturezasForm.vue'),
      meta: {
        rules: ['SOL-001'],
    }
    },
    {
      path: ':id/atualizar',
      name: 'Naturezas_Atualizar',
      component: () => import('./NaturezasForm.vue'),
      meta: {
        rules: ['SOL-001'],
    }
    },
  ],
  meta: {
    rules: ['SOL-001'],
}
}

export default routes;